import {Form, Input, Spin, Upload} from 'antd';
import styles from './mobileMoney.module.scss';
import {Button} from '@dabafinance/react-components';
import {
  UploadDocumentToBucket,
  resizeImageFile,
} from 'pages/campaigns/new/screens/legalDocument/uploadDocument';
import imgUpload from 'images/upload_image.png';

import {useState} from 'react';
import SubmitButton from 'components/Startup/components/SubmitButton';
import {toast} from 'react-toastify';

const MobileMoneyGuide = ({providerName, value, onSave}) => {
  const [progress, setProgress] = useState(0);
  const [loadingImageUpload, setLoadingImageUpload] = useState(false);
  const [imgURL, setImgURL] = useState(value?.imgURL ?? '');
  const [form] = Form.useForm();

  const handleChangeImage = async file => {
    if (!file) return;
    setLoadingImageUpload(true);
    try {
      const resized = await resizeImageFile(file);
      const url = await UploadDocumentToBucket(
        resized,
        setProgress,
        'momo-operators-logo',
      );
      setImgURL(url);
    } catch (error) {
      toast.error('Failed to upload the guide image. Please try again.');
    } finally {
      setLoadingImageUpload(false);
      setProgress(0);
    }
  };

  const handleSave = values => {
    if (loadingImageUpload) {
      return toast.error('Wait for the image upload to finish.');
    }
    onSave({
      description: values?.description?.trim() ?? '',
      link: values?.link?.trim() ?? '',
      videoURL: values?.videoURL?.trim() ?? '',
      imgURL,
    });
  };

  return (
    <div className={styles.modalRoot}>
      <h1>{providerName || 'Operator'} Guide</h1>
      <Form
        form={form}
        onFinish={handleSave}
        layout="vertical"
        initialValues={{
          description: value?.description ?? '',
          link: value?.link ?? '',
          videoURL: value?.videoURL ?? '',
        }}>
        {imgURL ? (
          <div className={styles['c-image-uploaded']}>
            <img src={imgURL} alt="" />
            <Button
              className={styles['delete-button']}
              label="Change Image"
              type="secondary"
              onClick={() => setImgURL('')}
            />
          </div>
        ) : (
          <Upload
            accept=".png, .jpeg, .jpg"
            name="file"
            showUploadList={false}
            beforeUpload={file => {
              handleChangeImage(file);
              return false;
            }}>
            <div className={styles['c-company-upload']}>
              {loadingImageUpload ? (
                <div className={styles['loading-spinner']}>
                  <h2>{progress}%</h2>
                  <Spin size="large" />
                  <h2>Loading...</h2>
                </div>
              ) : (
                <>
                  <img
                    className={styles['company-image']}
                    src={imgUpload}
                    alt="upload"
                  />
                  <div style={{marginTop: 6}}>Upload Image</div>
                </>
              )}
            </div>
          </Upload>
        )}
        <Form.Item
          name="description"
          className={styles.modalField}
          label="Description">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item
          name="videoURL"
          className={styles.modalField}
          rules={[{message: 'Provide a valid URL', type: 'url'}]}
          label="Video URL">
          <Input placeholder="https://" />
        </Form.Item>
        <Form.Item
          name="link"
          className={styles.modalField}
          rules={[{message: 'Provide a valid URL', type: 'url'}]}
          label="Additional Link">
          <Input placeholder="https://" />
        </Form.Item>
        <SubmitButton disabled={loadingImageUpload} label="Save and Close" />
      </Form>
    </div>
  );
};

export default MobileMoneyGuide;
